export DsfHomeTabPanel from "./tabPanel.vue";
export const DsfTabPanelSetting = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_output_common" */ "./tabPanelSetting"));
